<template>

    <div v-if="loading" class="text-center mt-5">

        <div class="spinner-border" role="status">
        </div>
    </div>
    <div v-else>
        <template v-if="error">
             <NotFound/> 
        </template>

        <template v-else>
            <NavbarView :data="legalData" :apiUrlStorage="apiUrlStorage" ></NavbarView>
            <div v-html="legalData.brand.whitelabel_all_in_one_terms_conditions"></div>
             <FooterViewD :data="legalData" :apiUrlStorage="apiUrlStorage" :signature="signature"/>

        </template>
    </div>

</template>

<script>
import { mapActions, mapState } from "vuex";
import NotFound from "@/components/errors/NotFound.vue";
import FooterViewD from "@/components/desktop/FooterView.vue";
import NavbarView from "@/components/NavbarView.vue";
export default {
    components: {
        NotFound,
        FooterViewD,
        NavbarView
  
  },
    async mounted() {
        await this.loadLegalData({
            id: this.$route.params.id,
            lang: this.$route.query.lang, 
        });

    },

    methods: {
        ...mapActions(['loadLegalData']),
    },

    computed: {
        ...mapState(['loading', 'error', 'legalData', 'apiUrlStorage', 'signature']),
    },
}
</script>

<style>
  body {
    padding-bottom: 0px !important;  
    padding-top: 0px !important;  
}
</style>



 